import React from "react";
import { Link } from "react-router-dom";

function Rise() {
  const data = [
    {
      id: 1,
      img1: "assets/images/blog/blog-a-1.png",
      img2: "assets/images/blog/blog-1-1.jpg",
      name: "Rise Design Thin king Problems Stra Development",
    },
    {
      id: 2,
      img1: "assets/images/blog/blog-a-2.png",
      img2: "assets/images/blog/blog-1-2.jpg",
      name: "Carson Shold wrote Improving Pmance Shopify Themes (Case Study)",
    },
    {
      id: 3,
      img1: "assets/images/blog/blog-a-3.png",
      img2: "assets/images/blog/blog-1-3.jpg",
      name: "Organize Related Assets And Borate Better",
    },
    {
      id: 4,
      img1: "assets/images/blog/blog-a-4.png",
      img2: "assets/images/blog/blog-1-4.jpg",
      name: "Meet Optimization New Smashin Book Addy Osmani",
    },
    {
      id: 5,
      img1: "assets/images/blog/blog-a-5.png",
      img2: "assets/images/blog/blog-1-5.jpg",
      name: "Rise Design Thin king Problems Stra Development",
    },
  ];

  const data2 = [
    {
      id: 1,
      img: "assets/images/blog/blog-s-1.png",
      name: "Meet Image Optimization Smashing Book Addy",
    },
    {
      id: 2,
      img: "assets/images/blog/blog-s-2.png",
      name: "Bake Layers Accessibility Testing Into Process",
    },
    {
      id: 3,
      img: "assets/images/blog/blog-s-3.png",
      name: "Newly Supporte Modern CSS Pseudo Class",
    },
    {
      id: 4,
      img: "assets/images/blog/blog-s-4.png",
      name: "Podcast Episode 36 With Miriam Suzanne Future",
    },
  ];
  return (
    <>
      <div className="blog-page">
        <div className="container">
          <div className="row gutter-y-60">
            <div className="col-md-12 col-lg-8">
              {data.map((item) => (
                <div className="blog-card" key={item.id}>
                  <ul className="list-unstyled blog-card__meta">
                    <li>
                      <img src={item.img1} />
                      <div className="blog-card__meta__content">
                        <div className="blog-card__meta__label">Post by</div>

                        <Link to="#">Larry S. Bisson</Link>
                      </div>
                    </li>
                    <li>
                      <div className="blog-card__meta__label">
                        <i className="far fa-calendar-alt" />
                        Nov
                      </div>

                      <Link to="#">25, 2022</Link>
                    </li>
                    <li>
                      <div className="blog-card__meta__label">
                        <i className="far fa-comments" />
                        Comments
                      </div>

                      <Link to="#">(05)</Link>
                    </li>
                  </ul>

                  <div className="blog-card__right">
                    <div className="blog-card__image">
                      <img src={item.img2} />
                    </div>

                    <div className="blog-card__content">
                      <h3 className="blog-card__title">
                        <Link to="/blogdetails">{item.name}</Link>
                      </h3>
                      <div className="blog-card__btns">
                        <Link
                          to="/insurances"
                          className="thm-btn thm-btn--two blog-card__btn"
                        >
                          <span>
                            Read More
                            <i className="far fa-arrow-right" />
                          </span>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              ))}

              <div className="blog-pagination--outer">
                <div className="blog-pagination">
                  <Link className="prev page-numbers" to="#">
                    <b>
                      <i className="far fa-arrow-left" />
                    </b>
                  </Link>
                  <span className="page-numbers current">
                    <b>01</b>
                  </span>
                  <Link className="page-numbers" to="#">
                    <b>02</b>
                  </Link>
                  <Link className="page-numbers" to="#">
                    <b>03</b>
                  </Link>
                  <Link className="page-numbers" to="#">
                    <b>04</b>
                  </Link>
                  <Link className="next page-numbers" to="#">
                    <b>
                      <i className="far fa-arrow-right" />
                    </b>
                  </Link>
                </div>
              </div>
            </div>

            <div className="col-md-12 col-lg-4">
              <div className="blog-sidebar">
                <div className="blog-sidebar__widget">
                  <h3 className="blog-sidebar__title">Search</h3>

                  <form action="#" className="blog-sidebar__search">
                    <input type="text" placeholder="Keywords" />
                    <button type="submit">
                      <i className="far fa-search" />
                    </button>
                  </form>
                </div>

                <div className="blog-sidebar__widget">
                  <h3 className="blog-sidebar__title">Categorys</h3>

                  <ul className="blog-sidebar__list">
                    <li>
                      <Link to="#">Life Insurance</Link>
                      (05)
                    </li>
                    <li>
                      <Link to="#">Health Insurance</Link>
                      (03)
                    </li>
                    <li>
                      <Link to="#">Study Insurance</Link>
                      (07)
                    </li>
                    <li>
                      <Link to="#">Car Insurance</Link>
                      (04)
                    </li>
                    <li>
                      <Link to="#">Fire Insurance</Link>
                      (08)
                    </li>
                    <li>
                      <Link to="#">Business Insurance</Link>
                      (02)
                    </li>
                  </ul>
                </div>

                <div className="blog-sidebar__widget">
                  <h3 className="blog-sidebar__title">Recent News</h3>

                  <ul className="blog-sidebar__post">
                    {data2.map((item) => (
                      <li key={item.id}>
                        <img src={item.img} />
                        <div className="blog-sidebar__post__content">
                          <p className="blog-sidebar__post__date">
                            <i className="far fa-calendar-alt" />
                            November 25, 2022
                          </p>
                          <h4 className="blog-sidebar__post__title">
                            <Link to="/blogdetails">{item.name} </Link>
                          </h4>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="blog-sidebar__widget blog-sidebar__widget--tags">
                  <h3 className="blog-sidebar__title">Popular Tags</h3>

                  <p className="blog-sidebar__tags">
                    <Link to="#">
                      <span>Insurance</span>
                    </Link>
                    <Link to="#">
                      <span>House</span>
                    </Link>
                    <Link to="#">
                      <span>Medical</span>
                    </Link>
                    <Link to="#">
                      <span>Banking</span>
                    </Link>
                    <Link to="#">
                      <span>Car Insurance</span>
                    </Link>
                    <Link to="#">
                      <span>Fire</span>
                    </Link>
                    <Link to="#">
                      <span>Study</span>
                    </Link>
                    <Link to="#">
                      <span>Business</span>
                    </Link>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Rise;
